import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerCrossedFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m24.325 26.023 4.648 4.647 1.697-1.697L3.03 1.333 1.333 3.03l7.224 7.225c-2.174.514-2.562 1.962-2.562 5.74 0 5.25.75 6 6 6q.31 0 .599-.004.642.433 1.365.912l4.216 2.807c2.934 1.953 4.4 2.929 5.444 1.818.327-.35.552-.84.706-1.505m.336-6.445L14.086 9.002l4.089-2.722c2.934-1.953 4.4-2.929 5.444-1.818s1.043 3.65 1.043 8.727z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SpeakerCrossedFilledSize32Glyph.displayName = 'SpeakerCrossedFilledSize32Glyph';
